import { Card, CardContent, Grid, Typography, useTheme } from '@mui/material';
import type React from 'react';
import type { Stats } from './useHelpdeskData';

interface HelpdeskStatsProps {
  stats: Stats;
}

export const HelpdeskStats: React.FC<HelpdeskStatsProps> = ({ stats }) => {
  const theme = useTheme();

  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card>
          <CardContent>
            <Typography variant="h6" sx={{ fontSize: '1.1rem' }}>
              {stats.total}
            </Typography>
            <Typography variant="body2" color="text.primary" sx={{ fontSize: '1.1rem' }}>
              Total Tickets
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card>
          <CardContent>
            <Typography variant="h6" color="text.primary" sx={{ fontSize: '1.1rem' }}>
              {stats.open}
            </Typography>
            <Typography variant="body2" color="text.primary" sx={{ fontSize: '1.1rem' }}>
              Open Tickets
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card>
          <CardContent>
            <Typography variant="h6" color="warning.main" sx={{ fontSize: '1.1rem' }}>
              {stats.inProgress}
            </Typography>
            <Typography
              variant="body2"
              color="greyContrast"
              sx={{ backgroundColor: theme.palette.greyLight, fontSize: '1.1rem' }}
            >
              In Progress
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card>
          <CardContent>
            <Typography variant="h6" sx={{ fontSize: '1.1rem' }}>
              {stats.avgResponseTime}m
            </Typography>
            <Typography variant="body2" color="text.primary" sx={{ fontSize: '1.1rem' }}>
              Avg Response Time
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
